import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HomeComponent } from '../../../home/home.component';
import { menuOptions } from 'src/data/menu-options.data';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { RequestHistoryService } from 'src/app/services/requests/history/request-history.service';

@Component({
  selector: 'spe-reprocessamento',
  templateUrl: './reprocessamento.component.html',
  styleUrls: ['./reprocessamento.component.scss'],
  standalone: false
})
export class ReprocessamentoComponent implements OnInit {
  private dialogReference?: MatDialogRef<ConfirmDialogComponent, any>;
  id: number = 0;
  isFromFuncionario: boolean = false;
  isImportacao: boolean = true;

  @ViewChild('createDialogTemplate') createDialogTemplate: TemplateRef<any> | undefined;

  constructor(
    private homeComponent: HomeComponent,
    private routerService: Router,
    private readonly dialog: MatDialog,
    private requestHistoryService: RequestHistoryService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.isFromFuncionario = params['funcionarios'] == 'S';
      this.isImportacao = params['importacao'] == 'S';
    });
    this.getProcessamentos();
    if(this.isImportacao){
      this.homeComponent.setNewVariables('Importação de Arquivo CSV Personalizado', 'Importação processando', 'importacao/importar-arquivo/csv-personalizado');
      
    }else{
      this.homeComponent.setNewVariables('Pedidos', 'Pedido processando', 'pedidos/acompanhamento');
    }
    this.homeComponent.idleMenuContent = menuOptions[2].content;
  }


   get validaImportacao(): boolean {
    return this.isImportacao ;
  }



  readonly returnButton = () => {
    this.dialogReference?.close();
    this.routerService.navigate([`home/pedidos/acompanhamento`]);
  };


  readonly returnImportacaoButton = () => {
    this.dialogReference?.close();
    this.routerService.navigate([`home/importacao/importar-arquivo/csv-personalizado`]);
  };

  

  readonly corrigirButton = () => {
    this.dialogReference?.close();
    this.routerService.navigate([`home/pedidos/acompanhamento/detalhes/${this.id}`]);
  };

  createDialog = (): Object => {
    const data = {
      title: 'Pedido com erro no processamento',
      component: this.createDialogTemplate,
      confirmAction: this.corrigirButton,
      body: `Opções do menu bloqueada pois existe um Pedido com Erro no Processamento.
      Para desbloquear é necessário que corrija os dados da solicitação do pedido.`,
      confirm: 'Corrigir',
      lowerBody: 'Selecione abaixo uma opção:'
    };

    return { panelClass: 'full-bleed-dialog', width: '600px', data: data };
  };

  getProcessamentos() {
    this.requestHistoryService.listarProcessamentos().subscribe({
      next: (data) => {
        if (data?.listaPedidosComErro?.length > 0) {
          this.id = data.listaPedidosComErro[0].id;
          if (this.isFromFuncionario) {
            this.dialogReference = this.dialog.open(ConfirmDialogComponent, this.createDialog());
          }
        }
      }
    });
  }
}
